<svg class="h-full w-full" xmlns="http://www.w3.org/2000/svg">
  <use
    data-testid="flag"
    attr.href="assets/sprites/countries-sprite.svg#{{ country }}"
  />
</svg>
